/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

export function getVariableName( variable: Record<string, string> ): string {
	return Object.keys( variable )[ 0 ];
}
